import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "width", "height", "sizes", "srcset", "loading"]

import { type PropType } from "vue";
import { type PaymentImageData } from "../payment-type/logos/base";


export default /*@__PURE__*/_defineComponent({
  __name: 'payment-image',
  props: {
    imageData: {
        type: Array as PropType<PaymentImageData[]>,
        required: true,
    },
    lazy: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: __props.imageData[__props.imageData.length - 1].url,
    width: __props.imageData[0].width,
    height: __props.imageData[0].height,
    sizes: `(max-resolution: 300dpi) ${__props.imageData[0].width}px, ${
            __props.imageData[__props.imageData.length - 1].width
        }px`,
    srcset: 
            __props.imageData.map((image) => `${image.url} ${image.width}w`).join(', ')
        ,
    loading: __props.lazy ? 'lazy' : undefined
  }, null, 8 /* PROPS */, _hoisted_1))
}
}

})